// Selects used to get this free from native radios sharing a name. Options are
// not radios any more (a control inside role=option is nested-interactive), so
// the behaviour lives here.

const OPTION = '[role="option"]';
const FOCUSABLE = `${OPTION}:not([aria-disabled="true"])`;
const COMBOBOX = '[role="combobox"]';

const typing = (event) =>
  !event.metaKey && !event.ctrlKey && !event.altKey && (event.key.length === 1 || event.key === "Backspace");

class ElmListbox extends HTMLElement {
  connectedCallback() {
    this.onKeyDown = this.onKeyDown.bind(this);
    this.addEventListener("keydown", this.onKeyDown);
    this.combobox = this.parentElement.querySelector(COMBOBOX);

    if (this.combobox) {
      this.combobox.addEventListener("keydown", this.onKeyDown);
    } else {
      this.focus();
    }
  }

  disconnectedCallback() {
    this.removeEventListener("keydown", this.onKeyDown);
    this.combobox?.removeEventListener("keydown", this.onKeyDown);
  }

  own(selector) {
    return [...this.querySelectorAll(selector)].filter((node) => node.closest("elm-listbox") === this);
  }

  focus() {
    const options = this.own(FOCUSABLE);
    const selected = options.find((option) => option.getAttribute("aria-selected") === "true");

    (selected ?? options[0])?.focus();
  }

  onKeyDown(event) {
    const options = this.own(FOCUSABLE);
    const here = options.indexOf(event.target.closest(OPTION));

    if (here >= 0 && this.combobox && typing(event)) {
      // No preventDefault: the keystroke lands in whatever is focused when the
      // browser gets to it, so moving focus now is what carries it back.
      this.combobox.focus();
      return;
    }

    const target = here < 0 ? this.entry(event.key, options) : this.next(event.key, here, options);

    if (!target) return;

    // Otherwise the page scrolls under the open popup.
    event.preventDefault();
    target.focus();
  }

  entry(key, options) {
    return { ArrowDown: options[0], ArrowUp: options[options.length - 1] }[key];
  }

  next(key, here, options) {
    const step = { ArrowDown: 1, ArrowUp: -1 }[key];

    if (step) return options[(here + step + options.length) % options.length];
    if (key === "Home") return options[0];
    if (key === "End") return options[options.length - 1];

    return undefined;
  }
}

if (!customElements.get("elm-listbox")) {
  customElements.define("elm-listbox", ElmListbox);
}
